import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-26358935"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "questInfo"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-vote"
}, null, -1));
const _hoisted_3 = {
  class: "repic_check"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 多选 ");
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 2
};
const _hoisted_9 = {
  class: "tp_if"
};
const _hoisted_10 = {
  class: "vote_title"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "vote_cont"
};
const _hoisted_13 = ["src", "onClick"];
const _hoisted_14 = {
  class: "vote_txt render-line-clamp"
};
const _hoisted_15 = {
  key: 1,
  class: "vote_cont_precent"
};
const _hoisted_16 = {
  class: "vote-info"
};
const _hoisted_17 = /*#__PURE__*/_createTextVNode("人已投票 · ");
const _hoisted_18 = /*#__PURE__*/_createTextVNode("已结束");
const _hoisted_19 = /*#__PURE__*/_createTextVNode("天");
const _hoisted_20 = /*#__PURE__*/_createTextVNode("小时");
const _hoisted_21 = /*#__PURE__*/_createTextVNode("分");
const _hoisted_22 = /*#__PURE__*/_createTextVNode("秒");
const _hoisted_23 = /*#__PURE__*/_createTextVNode("结束 ");
const _hoisted_24 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questInfo.vote_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "hasQuest",
      key: index
    }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [item.type == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "单选")) : (_openBlock(), _createElementBlock("span", _hoisted_5, [_hoisted_6, item.min_select && item.max_select ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [item.min_select == item.max_select ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode(" ，可选" + _toDisplayString(item.min_select) + "项 ", 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createTextVNode("，可选" + _toDisplayString(item.min_select) + " - " + _toDisplayString(item.max_select) + "项", 1)], 64))], 64)) : item.min_select ? (_openBlock(), _createElementBlock("span", _hoisted_7, "，至少选" + _toDisplayString(item.min_select) + "项", 1)) : item.max_select ? (_openBlock(), _createElementBlock("span", _hoisted_8, "，至多选" + _toDisplayString(item.max_select) + "项", 1)) : _createCommentVNode("", true)]))]), _createElementVNode("div", _hoisted_9, _toDisplayString($data.rightMap[$data.questInfo.vote_right]), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.topic_name), 1), _createElementVNode("div", {
      class: _normalizeClass(['vote-all', $data.questInfo.if_end == 1 || item.is_select_vote == 1 ? 'end' : ''])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (sItem, sindex) => {
      return _openBlock(), _createElementBlock("div", {
        key: sindex,
        class: _normalizeClass(['li', sItem.is_select_item ? 'checked' : '', $data.checked_vote_items && $data.checked_vote_items.length && $data.checked_vote_items.includes(sItem.id) ? 'checked' : '']),
        onClick: $event => $options.checkVote(sItem, sindex, item, index)
      }, [item.is_select_vote || $data.questInfo.if_end == 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "precent",
        style: _normalizeStyle(`width:${sItem.percent}%;`)
      }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [sItem.img ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: $options.imgUrlFilter(sItem.img, 200),
        onClick: _withModifiers($event => $options.showBigImg(sindex, sItem.img), ["stop"])
      }, null, 8, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, _toDisplayString(sItem.title), 1), item.is_select_vote || $data.questInfo.if_end == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", null, _toDisplayString(sItem.vote_num) + "票", 1), _createElementVNode("div", null, _toDisplayString(sItem.percent) + "%", 1)])) : _createCommentVNode("", true)])], 10, _hoisted_11);
    }), 128))], 2), _createElementVNode("div", _hoisted_16, [item.vote_user_num ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("span", null, _toDisplayString(item.vote_user_num), 1), _hoisted_17], 64)) : _createCommentVNode("", true), $data.questInfo.if_end == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_hoisted_18], 64)) : $options.endTimeShow && $options.endTimeShow.length ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_createTextVNode("还有 " + _toDisplayString($options.endTimeShow[$options.endTimeShow.length - 1]) + " ", 1), $options.endTimeShow.length == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_19], 64)) : $options.endTimeShow.length == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_hoisted_20], 64)) : $options.endTimeShow.length == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_hoisted_21], 64)) : $options.endTimeShow.length == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [_hoisted_22], 64)) : _createCommentVNode("", true), _hoisted_23], 64)) : _createCommentVNode("", true)]), item.type == 1 && $data.questInfo.if_end == 0 && $data.checked_vote_items.length ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "vote-submit",
      onClick: $event => $options.sub_vote(item)
    }, "投票", 8, _hoisted_24)) : _createCommentVNode("", true)]);
  }), 128))]);
}